import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import airportList from "./new_airport_list.json";

const useStyles = makeStyles(() => ({
  comboOptions: {
    fontSize: "16px",
    color: "var(--darker)",
  },
  inputColor: {
    fontSize: "14px",
    color: "var(--darker)",
    fontWeight: 600,
  },
}));

export default function Asynchronous(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [inputText, setInputText] = useState("");
  const [options, setOptions] = useState([]);
  const [allAirports, setAllAirports] = useState([]);
  const loading = open && options.length === 0 && inputText.trim().length >= 3;

  useEffect(() => {
    setAllAirports(airportList);
  }, []);

  useEffect(() => {
    if (inputText.trim().length >= 3) {
      const searchText = inputText.trim().toLowerCase();

      const filtered = allAirports.filter((airport) => {
        return (
          airport?.CITYNAME?.trim().toLowerCase().includes(searchText) ||
          airport?.AIRPORTCODE?.trim().toLowerCase().includes(searchText) ||
          airport?.AIRPORTNAME?.trim().toLowerCase().includes(searchText)
        );
      });

      setOptions(
        filtered.length > 0
          ? filtered.slice(0, 10)
          : [{ AIRPORTNAME: "No matching airport found" }]
      );
    } else {
      setOptions([]);
    }
  }, [inputText, allAirports]);

  const handleChange = (e) => {
    setInputText(e.target.value);
  };

  const handleAutocompleteChange = (e, newValue) => {
    if (newValue && newValue.AIRPORTNAME !== "No matching airport found") {
      setInputText(newValue.AIRPORTNAME);
      props.onChange({
        code: newValue.AIRPORTCODE,
        name: newValue.AIRPORTNAME,
        city: newValue.CITYNAME,
        country: newValue.COUNTRYNAME,
      });
    }
  };

  return (
    <div className="myautocomplete">
      <Autocomplete
        freeSolo
        PaperComponent={({ children }) => (
          <Paper style={{ background: "var(--backgroundcolor)" }}>
            {children}
          </Paper>
        )}
        id="asynchronous-demo"
        open={open && inputText.trim().length >= 3}
        style={{ color: "var(--darker)" }}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        getOptionLabel={(option) =>
          option.AIRPORTNAME === "No matching airport found"
            ? option.AIRPORTNAME
            : `${option.AIRPORTNAME} (${option.AIRPORTCODE}) - ${option.CITYNAME} - ${option.COUNTRYNAME}`
        }
        options={options}
        renderOption={(option) => (
          <Typography className={classes.comboOptions}>
            {option.AIRPORTNAME === "No matching airport found"
              ? option.AIRPORTNAME
              : `${option.AIRPORTNAME} (${option.AIRPORTCODE}) - ${option.CITYNAME} - ${option.COUNTRYNAME}`}
          </Typography>
        )}
        inputValue={
          inputText === "No matching airport found" ? "" : inputText || ""
        }
        loading={loading}
        onChange={handleAutocompleteChange}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={props.placeholder}
            fullWidth
            style={{
              fontSize: "14px",
              color: "var(--darker)",
              fontWeight: 600,
            }}
            onChange={handleChange}
            onBlur={(e) => {
              if (inputText && options.length === 1) {
                handleAutocompleteChange(
                  e,
                  options && options.length > 0 ? options[0] : null
                );
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && options.length > 0) {
                const selectedOption = options.find(
                  (option) =>
                    option.AIRPORTNAME.toLowerCase() === inputText.toLowerCase()
                );
                if (selectedOption) {
                  handleAutocompleteChange(e, selectedOption);
                }
              }
            }}
            InputProps={{
              ...params.InputProps,
              className: classes.inputColor,
              endAdornment: loading ? <CircularProgress size={20} /> : null,
            }}
          />
        )}
      />
    </div>
  );
}

Asynchronous.defaultProps = {
  placeholder: "Type to search",
};
